//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      form: {
        type: "",
        name: "",
        title: '',
        content: '',
        height: ""
      },
      show_toast: false,
      toast_value: "",

    }
  },
  mounted() {
    this.form.type = this.$route.query.type
    if (localStorage.getItem("login_peo")) {
      this.form.name = JSON.parse(localStorage.getItem("login_peo")).name;
    } else {
      this.toast_value = "请登录";
      this.show_toast = true;
      let timer = setTimeout(() => {
        this.$router.push({
          path: '/my',
        });
      }, 800);
    }

  },
  components: {},
  methods: {
    onSubmit() { //提交数据

      if (this.form.title == "" || this.form.content == "") {
        this.toast_value = "信息不完整";
        this.show_toast = true;
        return;
      }

      this.$http.get('/upload/stu_upload.php', {
          params: {
            operate_type: 'up_question',
            type: this.form.type,
            name: this.form.name,
            title: this.form.title,
            ctn: this.form.content
          }
        }).then((res) => {

          if (res.data.status == 1) {
            this.toast_value = '上传成功';
            this.show_toast = true;
            let timer = setTimeout(() => {
              this.form.title = "";
              this.form.content = "";
              clearInterval(timer);
            }, 800);
          } else {
            this.toast_value = '上传失败';
            this.show_toast = true;
          }


        })
        .catch(function(error) {
          console.log(error);
        });
    },


  },
  watch: {
    title: function(val) {
      if (val.length > 10) {
        this.toast_value = '标题不能超过十个字符';
        this.show_toast = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/apply_question.vue